import { useState } from 'react';
import NewPlateTemplateSection from './NewPlateTemplateSection';

import useNavbar from './useNavbar';

function BlankSelection({creationArgs={}, setCreationArgs}){

  const designs = ["96-well","384-well"];

  const navbarArgs = {
    options:designs.map(opt => ({_id:opt, label:opt})), 
    onChange:val => {
      debugger;
      setCreationArgs({blank:val})
    },
    forceSelected:creationArgs?.blank
  }

  const [ selected, navbar] = useNavbar(navbarArgs, creationArgs?.blank||"null");


  let blankSelection = (
    <div class="fair-margin"> 

      <h5>Blank</h5>

      <div class="sg-row v-center">
        {navbar}

      </div>
    </div>
  )

  return blankSelection;
}



export default function NewPlateExperiment({setSelectedExperimentId,state,set}){

  const [ creationArgs, setCreationArgs ] = useState({});


  let enabled = !!creationArgs;
  

  


  const nextFooter = (
    <div class="sg-row">
      <div class="flex-expand"/>
      <button onClick={() => {

        let experimentId = "Experiment " + (Object.keys(state.experiments).length + 1)


        set({
          type:"createExperiment",
          creationArgs,
          experimentId,
        })


        setSelectedExperimentId(experimentId);



      }} 
      disabled={!enabled} class="btn btn-success">Next</button>
    </div>
  )


  return (
    <div style={{border:'2px solid blue'}} class="flex-expand">
      <div>New experiment</div>

      {true && <div>{JSON.stringify(creationArgs)}</div>}

 

      <BlankSelection {...{creationArgs,setCreationArgs}} />

      <NewPlateTemplateSection {...{creationArgs, setCreationArgs, state}}/>


      {nextFooter}
   

      
    </div>
  )



}
